import { DEFAULT_LOCALE } from '../locale.js';
import { en } from './en.js';
import { ru } from './ru.js';
const COPY = { ru, en };
/** тексты домена на языке человека */
export function domainCopy(locale = DEFAULT_LOCALE) {
    return COPY[locale];
}
//# sourceMappingURL=index.js.map